import { asString, isObject } from "./model-utils";

export class TrackLink {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.link = asString(json.link);
    this.tinyUrl = asString(json.tinyUrl);
  }

  static fromJson(json: any) {
    return isObject(json) ? new TrackLink(json) : json;
  }
}
